import request from "../request";

// 登录
export function login(data) {
  return request({
    url: `/interviewer/pc-user/login`,
    method: "post",
    data,
  });
}

// 修改密码
export function changePwd(data) {
  return request({
    url: `web/sys-user/system/updatePassWord`,
    method: "post",
    data,
  });
}
